import { http } from '@/http'

export default {
  list(params) {
    return http.get('/leave-types', { params })
  },
  get(id) {
    return http.get(`/leave-types/${id}`)
  },
  save(data) {
    return http.post('/leave-types', data)
  },
  update(id, data) {
    return http.put(`/leave-types/${id}`, data)
  },
  changeStatus(id, status) {
    return http.put(`/leave-types/${id}/status`, null, { params: { status } })
  },
  remove(id) {
    return http.delete(`/leave-types/${id}`)
  },
}
